import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BrandConfigService, Links } from '@mobi/oiv-viewer-utils-ng-jslib';
import {
    MobiUiFooterComponent,
    MobiUiLanguage,
    MobiUiOverlayComponent,
    MobiUiOverlayDirective,
} from '@mobi/rwc-ui-components-ng-jslib';
import { TranslatePipe } from '@mobi/rwc-utils-ng-jslib';
import { TealiumTrackLinkOffsiteDirective, TealiumTrackLinkOnsiteDirective } from '@mobi/tea-tagmanager-ng-jslib';

@Component({
    selector: 'oiv-viewer-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        MobiUiFooterComponent,
        TranslatePipe,
        MobiUiOverlayDirective,
        MobiUiOverlayComponent,
        TealiumTrackLinkOnsiteDirective,
        TealiumTrackLinkOffsiteDirective,
    ],
    providers: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
    #brandConfigService = inject(BrandConfigService);

    links = input<Links>();
    languageChange = output<MobiUiLanguage>();

    /**
     * Dynamically set company name based on brand
     */
    companyName = computed(() => {
        return this.#brandConfigService.isMobiliar() ? 'oiv.app.mobiliar' : 'oiv.footer.company.name';
    });

    onChange(language: MobiUiLanguage) {
        this.languageChange.emit(language);
    }
}
